import { useEffect, useRef, useState } from "react";
import { Eraser, Upload, PenLine } from "lucide-react";
import { toast } from "sonner";

export const SignaturePad = ({ value, onChange, disabled }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [mode, setMode] = useState("draw");

  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    if (value) {
      const img = new Image();
      img.onload = () => {
        const r = Math.min(c.width / img.width, c.height / img.height);
        ctx.drawImage(img, (c.width - img.width * r) / 2, (c.height - img.height * r) / 2, img.width * r, img.height * r);
      };
      img.src = value;
    }
  }, [value]);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return [((p.clientX - r.left) * ref.current.width) / r.width, ((p.clientY - r.top) * ref.current.height) / r.height];
  };
  const start = (e) => {
    if (disabled) return;
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.lineWidth = 3;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0b2a6b";
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(ref.current.toDataURL("image/png"));
  };
  const upload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 500 * 1024) return toast.error("Ukuran gambar maksimal 500 KB");
    const rd = new FileReader();
    rd.onload = () => onChange(rd.result);
    rd.readAsDataURL(file);
  };

  return (
    <div data-testid="signature-pad">
      <div className="flex gap-2 mb-2">
        <button type="button" onClick={() => setMode("draw")} className={`text-xs px-3 py-1.5 rounded-full border inline-flex items-center gap-1 ${mode === "draw" ? "bg-slate-900 text-white" : "bg-white"}`} data-testid="ttd-mode-draw"><PenLine className="h-3.5 w-3.5" /> Gambar</button>
        <label className={`text-xs px-3 py-1.5 rounded-full border inline-flex items-center gap-1 cursor-pointer ${disabled ? "opacity-50 pointer-events-none" : "bg-white hover:bg-slate-50"}`} data-testid="ttd-upload-label">
          <Upload className="h-3.5 w-3.5" /> Unggah gambar
          <input type="file" accept="image/png,image/jpeg" className="hidden" onChange={upload} data-testid="ttd-upload-input" />
        </label>
        <button type="button" disabled={disabled} onClick={() => onChange("")} className="text-xs px-3 py-1.5 rounded-full border bg-white inline-flex items-center gap-1 hover:bg-rose-50" data-testid="ttd-clear-button"><Eraser className="h-3.5 w-3.5" /> Hapus</button>
      </div>
      <canvas
        ref={ref} width={600} height={200} data-testid="ttd-canvas"
        className="w-full h-[150px] rounded-xl border-2 border-dashed border-slate-300 bg-[repeating-linear-gradient(0deg,#fff,#fff_29px,#eef2f7_30px)] touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      <p className="text-[11px] text-slate-500 mt-1">Tanda tangani di kotak atau unggah gambar tanda tangan (PNG latar transparan disarankan).</p>
    </div>
  );
};
